import { Payment, PaymentRest } from "../../../../../entities";
import { USE_REST_TRANSACTION_HISTORY } from "../../../../../entities/payment/payment.transaction-history.helpers";

type TransactionType = "deposit" | "withdraw";

export function usePaymentTransactionHistory(paymentType: TransactionType) {
  const legacyQuery = Payment.useTransactionHistory(paymentType);
  const restQuery = PaymentRest.useTransactionHistory(paymentType);

  return USE_REST_TRANSACTION_HISTORY ? restQuery : legacyQuery;
}
